var _defs, _g, _g2, _g3, _g4, _g5, _g6, _line, _g7, _g8, _g9, _g0, _g1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 891,
    height: 841,
    viewBox: "0 0 891 841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-car-pop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1Base007.991-395.4a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6A4.616,4.616,0,0,1,1007.991-524.317Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6A4.616,4.616,0,0,1,1007.991-556.545ZM977.582-395.4a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.605Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6ZM947.173-395.4a4.616,4.616,0,0,1-4.631-4.6,4.616,4.616,0,0,1,4.631-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.631-4.6,4.616,4.616,0,0,1,4.631-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.605Zm0-32.228a4.616,4.616,0,0,1-4.631-4.6,4.616,4.616,0,0,1,4.631-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.631-4.6,4.616,4.616,0,0,1,4.631-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.631-4.6,4.616,4.616,0,0,1,4.631-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.631-4.6,4.616,4.616,0,0,1,4.631-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6ZM915.441-395.4a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.605Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6ZM885.033-395.4a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.605Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.628,4.6ZM854.631-395.4a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm153.36,355.15a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6A4.616,4.616,0,0,1,1007.991-233.623Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6A4.616,4.616,0,0,1,1007.991-265.851Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.617,4.617,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6A4.616,4.616,0,0,1,1007.991-362.536ZM977.586-201.4a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.617,4.617,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6ZM947.177-201.4a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6ZM915.445-201.4a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6A4.616,4.616,0,0,1,915.445-233.623Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6A4.616,4.616,0,0,1,915.445-265.851Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6A4.616,4.616,0,0,1,915.445-362.536ZM885.037-201.4a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6A4.616,4.616,0,0,1,885.037-233.623Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6A4.616,4.616,0,0,1,885.037-265.851Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.617,4.617,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6A4.616,4.616,0,0,1,885.037-362.536ZM854.631-201.4A4.616,4.616,0,0,1,850-206a4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Zm0-32.228a4.616,4.616,0,0,1-4.632-4.6,4.616,4.616,0,0,1,4.632-4.6,4.616,4.616,0,0,1,4.632,4.6,4.616,4.616,0,0,1-4.632,4.6Z",
    transform: "translate(-851 565.754)",
    fill: "#13ab9f"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "",
    x: 218,
    y: 0,
    width: 673,
    height: 841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#989898",
    floodOpacity: 0.404
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2-car-pop"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -32,
    width: 396,
    height: 368,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-car-pop",
    x: 323,
    y: 105,
    width: 463,
    height: 700,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-2-car-pop",
    x: 323,
    y: 105,
    width: 463,
    height: 85,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-3-car-pop",
    x: 0,
    y: 136,
    width: 470,
    height: 570,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-4-car-pop",
    x: 30.095,
    y: 203,
    width: 427.905,
    height: 80.961,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-5-car-pop",
    x: 12,
    y: 251,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-6-car-pop",
    x: 12,
    y: 333,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-7-car-pop",
    x: 12,
    y: 415,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-8-car-pop",
    x: 12,
    y: 497,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-9-car-pop",
    x: 12,
    y: 579,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-10-car-pop",
    x: 150,
    y: 497,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-11-car-pop",
    x: 150,
    y: 579,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-12-car-pop",
    x: 288,
    y: 497,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-13-car-pop",
    x: 288,
    y: 579,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-14-car-pop",
    x: 150,
    y: 251,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-15-car-pop",
    x: 150,
    y: 333,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-16-car-pop",
    x: 150,
    y: 415,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-17-car-pop",
    x: 288,
    y: 251,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-18-car-pop",
    x: 288,
    y: 333,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base-19-car-pop",
    x: 288,
    y: 415,
    width: 170,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_70749",
    "data-name": "Raggruppa 70749",
    transform: "translate(-809.5 43.5)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_51706",
    "data-name": "Raggruppa 51706",
    transform: "translate(-60 -3240.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(1058.509 3920.131) rotate(-90)",
    clipPath: "url(#clip-path-car-pop)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M846.575-569.178h172.916v374.651H846.575Z",
    transform: "translate(-851.721 564.032)",
    fill: "#13ab9f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Intersezione_1",
    "data-name": "Intersezione 1",
    d: "M3232.31-1110.839h0Zm-28.05-10h0Zm-15.143-10h0Zm-10.789-10h0Zm-7.966-9.7h0Zm-6.042-9.442h0Zm-4.847-9.827h0Zm-3.592-9.828h0Zm-2.473-9.827h0Zm-1.442-9.828h0Zm-.466-9.827h0Zm.488-9.828h0Zm1.466-9.828h0Zm2.5-9.827h0Zm3.62-9.828h0Zm4.878-9.827h0Zm6.079-9.442h0Zm8.015-9.7h0Zm10.863-10h0Zm15.286-10h0Zm28.848-10h0Z",
    transform: "translate(-1649 4643.032)",
    fill: "none",
    stroke: "#13ab9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Conto",
    transform: "translate(475 -109.358)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 334.5, 65.86)",
    filter: "url(#Base-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-20-car-pop",
    "data-name": "Base",
    width: 418,
    height: 586,
    transform: "translate(343.5 122.5)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Total",
    transform: "translate(689 722.358)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_451",
    "data-name": "Rettangolo 451",
    width: 394,
    height: 41,
    rx: 4,
    fill: "#3a4750"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Pay",
    transform: "translate(17 24)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pay")), /*#__PURE__*/React.createElement("text", {
    id: "_240_00",
    "data-name": "$ 240,00",
    transform: "translate(368 24)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -59.033,
    y: 0
  }, "$ 240,00")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Sub_Total",
    "data-name": "Sub Total",
    transform: "translate(689.312 607.501)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Sub_Total-2",
    "data-name": "Sub Total",
    transform: "translate(-0.313 9.857)",
    fill: "#3a4750",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sub Total")), /*#__PURE__*/React.createElement("text", {
    id: "_200_00",
    "data-name": "$ 200,00",
    transform: "translate(392.688 11.857)",
    fill: "#3a4750",
    fontSize: 11,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -42.668,
    y: 0
  }, "$ 200,00")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Vat",
    transform: "translate(689.312 628.24)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Vat-2",
    "data-name": "Vat",
    transform: "translate(-0.313 12.119)",
    fill: "#3a4750",
    fontSize: 11,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Vat")), /*#__PURE__*/React.createElement("text", {
    id: "_40_00",
    "data-name": "$ 40,00",
    transform: "translate(389.688 10.119)",
    fill: "#3a4750",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.105,
    y: 0
  }, "$ 40,00")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Discount",
    transform: "translate(689.312 648.979)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Discount-2",
    "data-name": "Discount",
    transform: "translate(-0.313 12.379)",
    fill: "#3a4750",
    fontSize: 11,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Discount")), /*#__PURE__*/React.createElement("text", {
    id: "_0_00",
    "data-name": "$ 0,00",
    transform: "translate(361.688 12.379)",
    fill: "#3a4750",
    fontSize: 11,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$ 0,00")))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Divider",
    x2: 395,
    transform: "translate(689 596.358)",
    fill: "none",
    stroke: "#e2e2e3",
    strokeWidth: 1
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Split",
    transform: "translate(689 676.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_451-2",
    "data-name": "Rettangolo 451",
    fill: "none",
    stroke: "#3a464f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 394,
    height: 35,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 393,
    height: 34,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Split-2",
    "data-name": "Split",
    transform: "translate(197 22)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.275,
    y: 0
  }, "Split")))), /*#__PURE__*/React.createElement("g", {
    id: "Scroll_Group_11",
    "data-name": "Scroll Group 11",
    transform: "translate(689 260.358)",
    clipPath: "url(#clip-path-2-car-pop)",
    style: {
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Corsa_2",
    "data-name": "Corsa 2",
    transform: "translate(-694 -215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sedia_2",
    "data-name": "Sedia 2",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Sedia_2-2",
    "data-name": "Sedia 2",
    transform: "translate(694 579)",
    fill: "#b5b5b5",
    fontSize: 14,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sedia 2"))), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_6",
    "data-name": "Piatto 6"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_20_00",
    "data-name": "$ 20,00",
    transform: "translate(1008 546)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$ 20,00")), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(694 546)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "Orecchiette_con_Cime_di_Rapa",
    "data-name": "Orecchiette con Cime di Rapa",
    transform: "translate(718 546)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Orecchiette con Cime di Rapa")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete",
    "data-name": "Icon material-delete",
    d: "M8.357,18.722A1.752,1.752,0,0,0,10.071,20.5h6.857a1.752,1.752,0,0,0,1.714-1.778V8.056H8.357ZM19.5,5.389h-3L15.643,4.5H11.357l-.857.889h-3V7.167h12Z",
    transform: "translate(1070.5 528.5)",
    fill: "#bc181c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sedia_1",
    "data-name": "Sedia 1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Chair_1",
    "data-name": "Chair 1",
    transform: "translate(694 520)",
    fill: "#b5b5b5",
    fontSize: 14,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Chair 1"))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-navigate-next",
    "data-name": "Icon material-navigate-next",
    d: "M4.858,10,6,8.825,2.291,5,6,1.175,4.858,0,0,5Z",
    transform: "translate(1090 480) rotate(90)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2nd_course",
    "data-name": "2nd course",
    transform: "translate(694 488)",
    fill: "#b5b5b5",
    fontSize: 14,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2ND COURSE")))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Corsa_1",
    "data-name": "Corsa 1",
    transform: "translate(-694 -191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Piatto_5",
    "data-name": "Piatto 5",
    transform: "translate(0 -16)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_20_00-2",
    "data-name": "$ 20,00",
    transform: "translate(1008 447)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$ 20,00")), /*#__PURE__*/React.createElement("text", {
    id: "_1-2",
    "data-name": 1,
    transform: "translate(694 447)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "Gli_intrattieni",
    "data-name": "Gli intrattieni",
    transform: "translate(718 447)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Gli intrattieni")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-2",
    "data-name": "Icon material-delete",
    d: "M8.357,18.722A1.752,1.752,0,0,0,10.071,20.5h6.857a1.752,1.752,0,0,0,1.714-1.778V8.056H8.357ZM19.5,5.389h-3L15.643,4.5H11.357l-.857.889h-3V7.167h12Z",
    transform: "translate(1070.5 429.5)",
    fill: "#bc181c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Centro_Tavola",
    "data-name": "Centro Tavola",
    transform: "translate(0 -16)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Center_Piece",
    "data-name": "Center Piece",
    transform: "translate(694 421)",
    fill: "#b5b5b5",
    fontSize: 14,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Center Piece"))), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_4",
    "data-name": "Piatto 4",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_40_00-2",
    "data-name": "$ 40,00",
    transform: "translate(1008 388)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$ 40,00")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(694 388)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    id: "Battuti_e_carpacci",
    "data-name": "Battuti e carpacci",
    transform: "translate(718 388)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Battuti e carpacci")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-3",
    "data-name": "Icon material-delete",
    d: "M8.357,18.722A1.752,1.752,0,0,0,10.071,20.5h6.857a1.752,1.752,0,0,0,1.714-1.778V8.056H8.357ZM19.5,5.389h-3L15.643,4.5H11.357l-.857.889h-3V7.167h12Z",
    transform: "translate(1070.5 370.5)",
    fill: "#bc181c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_3",
    "data-name": "Piatto 3",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_20_00-3",
    "data-name": "$ 20,00",
    transform: "translate(1008 361)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$ 20,00")), /*#__PURE__*/React.createElement("text", {
    id: "_1-3",
    "data-name": 1,
    transform: "translate(694 361)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "I_taglieri_della_trattoria",
    "data-name": "I taglieri della trattoria",
    transform: "translate(718 361)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I taglieri della trattoria")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-4",
    "data-name": "Icon material-delete",
    d: "M8.357,18.722A1.752,1.752,0,0,0,10.071,20.5h6.857a1.752,1.752,0,0,0,1.714-1.778V8.056H8.357ZM19.5,5.389h-3L15.643,4.5H11.357l-.857.889h-3V7.167h12Z",
    transform: "translate(1070.5 343.5)",
    fill: "#bc181c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sedia_2-3",
    "data-name": "Sedia 2",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Chair_2",
    "data-name": "Chair 2",
    transform: "translate(694 335)",
    fill: "#b5b5b5",
    fontSize: 14,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Chair 2"))), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_2",
    "data-name": "Piatto 2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_20_00-4",
    "data-name": "$ 20,00",
    transform: "translate(1008 302)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$ 20,00")), /*#__PURE__*/React.createElement("text", {
    id: "_1-4",
    "data-name": 1,
    transform: "translate(694 302)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "Ortonala",
    transform: "translate(718 302)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ortonala")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-5",
    "data-name": "Icon material-delete",
    d: "M8.357,18.722A1.752,1.752,0,0,0,10.071,20.5h6.857a1.752,1.752,0,0,0,1.714-1.778V8.056H8.357ZM19.5,5.389h-3L15.643,4.5H11.357l-.857.889h-3V7.167h12Z",
    transform: "translate(1070.5 284.5)",
    fill: "#bc181c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1",
    "data-name": "Piatto 1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_20_00-5",
    "data-name": "$ 20,00",
    transform: "translate(1008 275)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$ 20,00")), /*#__PURE__*/React.createElement("text", {
    id: "_1-5",
    "data-name": 1,
    transform: "translate(694 275)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "Frittura_mista_di_calamari_e_gamberi",
    "data-name": "Frittura mista di calamari e gamberi",
    transform: "translate(718 275)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Frittura mista di calamari e gamberi")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-6",
    "data-name": "Icon material-delete",
    d: "M8.357,18.722A1.752,1.752,0,0,0,10.071,20.5h6.857a1.752,1.752,0,0,0,1.714-1.778V8.056H8.357ZM19.5,5.389h-3L15.643,4.5H11.357l-.857.889h-3V7.167h12Z",
    transform: "translate(1070.5 257.5)",
    fill: "#bc181c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sedia_1-2",
    "data-name": "Sedia 1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Chair_1-2",
    "data-name": "Chair 1",
    transform: "translate(694 249)",
    fill: "#b5b5b5",
    fontSize: 14,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Chair 1"))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-navigate-next-2",
    "data-name": "Icon material-navigate-next",
    d: "M4.858,10,6,8.825,2.291,5,6,1.175,4.858,0,0,5Z",
    transform: "translate(1090 209) rotate(90)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1st_course",
    "data-name": "1st course",
    transform: "translate(694 217)",
    fill: "#b5b5b5",
    fontSize: 14,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1ST COURSE")), /*#__PURE__*/React.createElement("text", {
    id: "TABLE_1",
    "data-name": "TABLE 1",
    transform: "translate(694 185)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TABLE 1"))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Add_to_Customer",
    "data-name": "Add to Customer",
    transform: "translate(678 188)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -343.5, -122.14)",
    filter: "url(#Base-2-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-21-car-pop",
    "data-name": "Base",
    width: 418,
    height: 40,
    transform: "translate(343.5 122.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Add_Customer",
    "data-name": "Add Customer",
    transform: "translate(41 23.358)",
    fill: "#3a4750",
    fontSize: 10,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Add Customer")), /*#__PURE__*/React.createElement("g", {
    id: "Add",
    transform: "translate(11.557 11.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_34664",
    "data-name": "Tracciato 34664",
    d: "M19.394,14.592H16.035V11.233a.721.721,0,1,0-1.443,0v3.359H11.233a.691.691,0,0,0-.721.721.7.7,0,0,0,.721.721h3.359v3.359a.7.7,0,0,0,.721.721.718.718,0,0,0,.721-.721V16.035h3.359a.721.721,0,1,0,0-1.443Z",
    transform: "translate(-6.645 -6.645)",
    fill: "#3a4750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_34665",
    "data-name": "Tracciato 34665",
    d: "M12.043,4.542a7.5,7.5,0,1,1-5.3,2.2,7.451,7.451,0,0,1,5.3-2.2m0-1.167a8.668,8.668,0,1,0,8.668,8.668,8.667,8.667,0,0,0-8.668-8.668Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#3a4750"
  }))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Cassa_Rapida",
    "data-name": "Cassa Rapida",
    transform: "translate(746 -26)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 63.5, -17.5)",
    filter: "url(#Base-3-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-22-car-pop",
    "data-name": "Base",
    width: 425,
    height: 525,
    transform: "translate(20.5 153.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cerca_Piatto",
    "data-name": "Cerca Piatto",
    transform: "translate(96 148)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Search",
    transform: "translate(1 9)",
    fill: "#55595c",
    fontSize: 9,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Search")), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_315",
    "data-name": "Rettangolo 315",
    transform: "translate(0 15)",
    fill: "#fff",
    stroke: "#ecebec",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 401,
    height: 28,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 400,
    height: 27,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Search-2",
    "data-name": "Search",
    transform: "translate(7 32)",
    fill: "#b5b5b5",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Search")), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_42242",
    "data-name": "Raggruppa 42242",
    transform: "translate(370 17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_3646",
    "data-name": "Rettangolo 3646",
    width: 25,
    height: 25,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "search-3",
    "data-name": "search",
    d: "M11.681,10.24,9.375,7.934a.555.555,0,0,0-.393-.162H8.6a4.809,4.809,0,1,0-.833.833v.377a.555.555,0,0,0,.162.393l2.306,2.306a.553.553,0,0,0,.784,0l.655-.655A.558.558,0,0,0,11.681,10.24ZM4.811,7.772A2.961,2.961,0,1,1,7.772,4.811,2.959,2.959,0,0,1,4.811,7.772Z",
    transform: "translate(7.03 6.948)",
    fill: "#707071"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Antipasti",
    transform: "translate(114 203)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -50.5, -220.5)",
    filter: "url(#Base-4-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-23-car-pop",
    "data-name": "Base",
    width: 382.905,
    height: 35.961,
    transform: "translate(50.59 220.5)",
    fill: "rgba(255,186,0,0.2)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Cocktails",
    transform: "translate(18 21.75)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cocktails")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V36H0Z",
    transform: "translate(0 0)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-2",
    "data-name": "Piatto 1",
    transform: "translate(96 251.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -32.5, -268.76)",
    filter: "url(#Base-5-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-24-car-pop",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(32.5 268.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Old_fashioned",
    "data-name": "Old fashioned",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Old fashioned")), /*#__PURE__*/React.createElement("text", {
    id: "Bourbon_zolletta_di_zucchero_angostura_bitter_acqua_naturale.",
    "data-name": "Bourbon, zolletta di zucchero, angostura bitter, acqua naturale.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Bourbon, zolletta di "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "zucchero, angostura bitter, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33
  }, "acqua naturale.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-2",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-3",
    "data-name": "Piatto 1",
    transform: "translate(96 333.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -32.5, -350.76)",
    filter: "url(#Base-6-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-25-car-pop",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(32.5 350.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Dry_Martini",
    "data-name": "Dry Martini",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Dry Martini")), /*#__PURE__*/React.createElement("text", {
    id: "Gin_Vermouth_Dry.",
    "data-name": "Gin, Vermouth Dry.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Gin, Vermouth Dry.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-3",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-4",
    "data-name": "Piatto 1",
    transform: "translate(96 415.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -32.5, -432.76)",
    filter: "url(#Base-7-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-26-car-pop",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(32.5 432.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Margarita",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Margarita")), /*#__PURE__*/React.createElement("text", {
    id: "Tequila_triple_sec_succo_fresco_di_limone_sale.",
    "data-name": "Tequila, triple sec, succo fresco di limone, sale.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Tequila, triple sec, succo "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "fresco di limone, sale.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-4",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-5",
    "data-name": "Piatto 1",
    transform: "translate(96 497.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -32.5, -514.76)",
    filter: "url(#Base-8-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-27-car-pop",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(32.5 514.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Aperol_Spritz",
    "data-name": "Aperol Spritz",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Aperol Spritz")), /*#__PURE__*/React.createElement("text", {
    id: "Aperol_Prosecco_Soda.",
    "data-name": "Aperol, Prosecco, Soda.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Aperol, Prosecco, Soda.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-5",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-6",
    "data-name": "Piatto 1",
    transform: "translate(96 579.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -32.5, -596.76)",
    filter: "url(#Base-9-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-28-car-pop",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(32.5 596.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Americano",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Americano")), /*#__PURE__*/React.createElement("text", {
    id: "Bitter_campari_vermouth_rosso_soda.",
    "data-name": "Bitter campari, vermouth rosso, soda.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Bitter campari, vermouth "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "rosso, soda.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-6",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-7",
    "data-name": "Piatto 1",
    transform: "translate(234 497.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -170.5, -514.76)",
    filter: "url(#Base-10-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-29-car-pop",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(170.5 514.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Bloody_Mary",
    "data-name": "Bloody Mary",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Bloody Mary")), /*#__PURE__*/React.createElement("text", {
    id: "Vodka_succo_di_pomodoro_succo_di_limone.",
    "data-name": "Vodka, succo di pomodoro, succo di limone.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Vodka, succo di "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "pomodoro, succo di "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33
  }, "limone.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-7",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-8",
    "data-name": "Piatto 1",
    transform: "translate(234 579.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -170.5, -596.76)",
    filter: "url(#Base-11-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-30-car-pop",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(170.5 596.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Cuba_Libre",
    "data-name": "Cuba Libre",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Cuba Libre")), /*#__PURE__*/React.createElement("text", {
    id: "Vodka_succo_di_pomodoro_succo_di_limone.-2",
    "data-name": "Vodka, succo di pomodoro, succo di limone.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Vodka, succo di "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "pomodoro, succo di "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33
  }, "limone.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-8",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-9",
    "data-name": "Piatto 1",
    transform: "translate(372 497.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -308.5, -514.76)",
    filter: "url(#Base-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-31",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(308.5 514.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Cosmopolitan",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Cosmopolitan")), /*#__PURE__*/React.createElement("text", {
    id: "Vodka_cointreau_succo_di_lime_succo_di_mirtilli.",
    "data-name": "Vodka, cointreau, succo di lime, succo di mirtilli.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Vodka, cointreau, succo di "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "lime, succo di mirtilli.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-9",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-10",
    "data-name": "Piatto 1",
    transform: "translate(372 579.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -308.5, -596.76)",
    filter: "url(#Base-13-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-32-car-pop",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(308.5 596.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Long_Island_Ice_Tea",
    "data-name": "Long Island Ice Tea",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Long Island Ice Tea")), /*#__PURE__*/React.createElement("text", {
    id: "Vodka_gin_rum_bianco_bacardi_cointreau_succo_di_limone_coca_cola.",
    "data-name": "Vodka, gin, rum bianco, bacardi, cointreau, succo di limone, coca cola.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Vodka, gin, rum bianco, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "bacardi, cointreau, succo "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33
  }, "di limone, coca cola.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-10",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-11",
    "data-name": "Piatto 1",
    transform: "translate(234 251.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -170.5, -268.76)",
    filter: "url(#Base-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-33",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(170.5 268.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Negroni",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Negroni")), /*#__PURE__*/React.createElement("text", {
    id: "Campari_vermouth_rosso_gin.",
    "data-name": "Campari, vermouth rosso, gin.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Campari, vermouth rosso, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "gin.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-11",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-12",
    "data-name": "Piatto 1",
    transform: "translate(234 333.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -170.5, -350.76)",
    filter: "url(#Base-15-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-34-car-pop",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(170.5 350.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Whiskey_Sour",
    "data-name": "Whiskey Sour",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Whiskey Sour")), /*#__PURE__*/React.createElement("text", {
    id: "Bourbon_whiskey_succo_di_limone_sciroppo_di_zucchero.",
    "data-name": "Bourbon whiskey, succo di limone, sciroppo di zucchero.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Bourbon whiskey, succo di "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "limone, sciroppo di "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33
  }, "zucchero.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-12",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-13",
    "data-name": "Piatto 1",
    transform: "translate(234 415.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -170.5, -432.76)",
    filter: "url(#Base-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-35",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(170.5 432.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Manhattan",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Manhattan")), /*#__PURE__*/React.createElement("text", {
    id: "Rye_Whiskey_vermouth_rosso_gocce_angostura.",
    "data-name": "Rye Whiskey, vermouth rosso, gocce angostura.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Rye Whiskey, vermouth "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "rosso, gocce angostura.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-13",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-14",
    "data-name": "Piatto 1",
    transform: "translate(372 251.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -308.5, -268.76)",
    filter: "url(#Base-17-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-36-car-pop",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(308.5 268.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Daiquiri",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Daiquiri")), /*#__PURE__*/React.createElement("text", {
    id: "Rum_bianco_succo_di_lime_fresco_sciroppo_zucchero.",
    "data-name": "Rum bianco, succo di lime fresco, sciroppo zucchero.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Rum bianco, succo di lime "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "fresco, sciroppo zucchero.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-14",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-15",
    "data-name": "Piatto 1",
    transform: "translate(372 333.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -308.5, -350.76)",
    filter: "url(#Base-18-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-37-car-pop",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(308.5 350.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Espresso_Martini",
    "data-name": "Espresso Martini",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Espresso Martini")), /*#__PURE__*/React.createElement("text", {
    id: "Vodka_liquore_al_caff\\xE8_sciroppo_di_zucchero_un_espresso.",
    "data-name": "Vodka, liquore al caff\\xE8, sciroppo di zucchero, un espresso.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Vodka, liquore al caff\xE8,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "sciroppo di zucchero,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33
  }, "un espresso.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-15",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Piatto_1-16",
    "data-name": "Piatto 1",
    transform: "translate(372 415.262)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -308.5, -432.76)",
    filter: "url(#Base-19-car-pop)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-38-car-pop",
    "data-name": "Base",
    width: 125,
    height: 70,
    transform: "translate(308.5 432.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Mojito",
    transform: "translate(12 5.738)",
    fill: "#3a4750",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "Mojito")), /*#__PURE__*/React.createElement("text", {
    id: "Rum_bianco_menta_acqua_gassata_succo_di_lime_zucchero_ghiaccio.",
    "data-name": "Rum bianco, menta, acqua gassata, succo di lime, zucchero, ghiaccio.",
    transform: "translate(12 27.738)",
    fill: "#3a4750",
    fontSize: 9,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Rum bianco, menta, acqua "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "gassata, succo di lime, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33
  }, "zucchero, ghiaccio.")), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33222-16",
    "data-name": "Tracciato 33222",
    d: "M0,0H6V70H0Z",
    transform: "translate(0 -0.262)",
    fill: "#ffba00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-expand-more",
    "data-name": "Icon material-expand-more",
    d: "M10.39,7.358,5.887,2.81l-4.5,4.548L0,5.958,5.887,0l5.887,5.958Z",
    transform: "translate(96 227.773) rotate(-90)",
    fill: "#3a4750"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPop);
export default __webpack_public_path__ + "static/media/pop.f2ebdd232f7c424c6baaa4ac03186a78.svg";
export { ForwardRef as ReactComponent };